import React, { useState, useEffect } from 'react';

const PROVIDERS = [
  'openai',
  'anthropic',
  'google-gemini',
  'azure-openai',
  'openrouter',
  'groq',
  'ollama',
  'nvidia-nim',
  'deepseek',
  'mistral',
];

const SettingsPage: React.FC = () => {
  useEffect(() => {
    const saved: Record<string, string> = {};
    PROVIDERS.forEach((p) => {
      const key = `NEURAL_API_KEY_${p.toUpperCase()}`;
      saved[p] = localStorage.getItem(key) || '';
    });
    setKeys(saved);
  }, []);

  const [keys, setKeys] = useState<Record<string, string>>({});
  const [status, setStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleChange = (provider: string, value: string) => {
    const updated = { ...keys, [provider]: value };
    setKeys(updated);
  };

  const handleSave = async () => {
    if (status === 'saving') return;
    setStatus('saving');
    setMessage('');
    try {
      Object.entries(keys).forEach(([provider, value]) => {
        if (value) {
          localStorage.setItem(`NEURAL_API_KEY_${provider.toUpperCase()}`, value);
        } else {
          localStorage.removeItem(`NEURAL_API_KEY_${provider.toUpperCase()}`);
        }
      });
      setStatus('saved');
      setMessage('Configurações salvas com sucesso.');
    } catch (err) {
      console.error(err);
      setMessage('Falha ao salvar configurações.');
      setStatus('error');
    }
    setTimeout(() => setStatus('idle'), 2000);
  };

  return (
    <div className="space-y-6 p-6 bg-zinc-950 text-zinc-100 min-h-screen">
      <h1 className="text-2xl font-semibold">Configurações da Neural</h1>
      {message && (
        <div className="rounded-md p-2 bg-zinc-800">{message}</div>
      )}
      <form className="grid grid-cols-1 gap-4">
        {PROVIDERS.map((provider) => (
          <div key={provider}>
            <label className="block font-medium mb-1">{provider.toUpperCase()} API Key</label>
            <input
              type="password"
              value={keys[provider] ?? ''}
              onChange={(e) => handleChange(provider, e.target.value)}
              className="border rounded-md p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-zinc-500"
              placeholder={`Enter ${provider} API key`}
            />
          </div>
        ))}
        <button
          type="button"
          onClick={handleSave}
          disabled={status === 'saving'}
          className="self-start px-4 py-2 bg-zinc-600 text-white rounded-md hover:bg-zinc-700 focus:outline-none focus:ring-2 focus:ring-zinc-500"
          title={status === 'saving' ? 'Salvar...' : 'Salvar configurações'}
        >
          {status === 'saving' ? 'Salvando...' : 'Salvar'}
        </button>
      </form>
    </div>
  );
};

export default SettingsPage;